import React from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import styled from "styled-components";
import "./App.css";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import { AuthProvider } from "./contexts/AuthContext";
import { SearchProviderContextProvider } from "./contexts/SearchProviderContext";
import { ThemeContextProvider } from "./contexts/ThemeContext";
import Callback from "./scenes/Callback";
import ClaroOffer from "./scenes/ClaroOffer";
import ConnectionStatus from "./scenes/ConnectionStatus/ConnectionStatus";
import ErrorPage from "./scenes/Error";
import ErrorBoundary from "./scenes/ErrorBoundary";
import Family from "./scenes/Family/Family";
import ProviderIntegrator from "./scenes/ProviderIntegrator";
import ProviderRedirect from "./scenes/ProviderRedirect";
import ProviderSelection from "./scenes/ProviderSelection";
import ProviderSignIn from "./scenes/ProviderSignIn";
import Success from "./scenes/Success";
import TermsOfUse from "./scenes/TermsOfUse";
import * as V2 from "./scenes";
import { Colors, theme } from "./theme";

const Base = styled.div`
  display: flex;
  flex-direction: column;
  background: ${theme(Colors.white, Colors.gray[500])};
  min-height: 100vh;
`;

const BaseContent = styled.main`
  min-height: calc(100vh - 495px);
`;

const AppLayout = () => (
  <Base>
    <Header />

    <BaseContent>
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </BaseContent>

    <Footer />
  </Base>
);

const App = () => {
  return (
    <Routes>
      <Route path="/ping" element={<ConnectionStatus />} />

      <Route
        element={
          <ThemeContextProvider>
            <AuthProvider>
              <Outlet />
            </AuthProvider>
          </ThemeContextProvider>
        }
      >
        <Route element={<AppLayout />}>
          <Route path="/callback" element={<Callback />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/success" element={<Success />} />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="/family" element={<Family />} />
          <Route path="/signin" element={<ProviderSignIn />} />
          <Route path="/redirect" element={<V2.RedirectProvider />} />

          <Route
            path="/providers/:providerId/services/:serviceId"
            element={<ProviderIntegrator />}
          />
          <Route path="/callback/gsat" element={<Callback />} />
          <Route
            path="/providers/:providerId/redirect"
            element={<ProviderRedirect />}
          />

          <Route path="/verify" element={<V2.VerifyAssociations />} />

          <Route
            path="/:serviceId"
            element={
              <SearchProviderContextProvider>
                <ProviderSelection />
              </SearchProviderContextProvider>
            }
          />

          <Route path="/v2/terms" element={<V2.TermsOfUse />} />
        </Route>

        <Route path="/offer-claro" element={<ClaroOffer />} />
      </Route>
    </Routes>
  );
};

export default App;
